import requestHelper from "../../plugins/requestHelper";
import { findClosestElementByClass } from "../helpers/dom/closest";
import errors from "../../plugins/errors";
import { initGauges } from "../gauge/gauges";
import { toggleOfferTableDropdownList } from "./toggleOfferTableDropdownList";
import { toggleOfferTableMobileItems } from "./toggleOfferTableMobileItems";
import { priceWrapper } from "./priceWrapper";
import { toggleOfferTableComparisonPopup } from "./toggleOfferTableComparisonPopup";
import lozad from "lozad/dist/lozad.js";
import { paralax } from "../../plugins/paralax";
import { elements } from "../helpers/dom/elementsManagement";
import { prepareAllPossibleSearchEngines } from "../searchChannels/searchChannels";
import { eDropdown } from "../dropdown/dropdown";
import { dropdownAnimation } from "../dropdown/dropdownAnimation";
import { dAction } from "../dataAction/dataAction";
import { toggleBox } from "../toggleBox/toggleBox";
import { approvals } from "../approvals/approvals";
import { formInputs } from "../forms/inputs";
import { sForm } from "../ajaxForm/ajax";
import { bindTooltip } from "../../../vendors/tooltips";
import alignItems from "../../plugins/alignItems";
import scrollTo from "../../plugins/scrollTo";
// import * as skrollr from 'skrollr';

Vue.component("offer-table", {
	delimiters: ["{[{", "}]}"],
	props: ["dataofferurl", "activate"],
	data: function () {
		return {
			offer_table: null,
			offer_table_mobile: null,
			switches: null,
			bonus: null,
			packages: null,
			popups: null,
			one_column: false,
			two_columns: false,
			three_columns: false,
			query: [],
			activated: false,
			active: this.activate,
			dataElement: null,
		};
	},
	watch: {
		active(newValue, oldValue) {
			// console.log('updated', this.activate);
			if (newValue === true && !this.activated) {
				this.fetchData();
				this.activated = true;
			}
		},
	},
	created() {
		if (this.active === "true") {
			this.fetchData();
		}
	},
	updated() {
		bindTooltip();
		initGauges();
		// priceWrapper();
		toggleOfferTableDropdownList();
		toggleOfferTableMobileItems();
		toggleOfferTableComparisonPopup();
		eDropdown.init();
		dropdownAnimation.offerDropdown();
		dAction.init();
		toggleBox.toggle({
			targetClassName: "contactAcceptances",
			parentClassName: "contact-box__approvals",
			contentClassName: "contactApprovalsContent",
			state: "showHide",
		});
		approvals.acceptAll(
			"totalCheck",
			"contact-box__approvals",
			"contactApprovalsContent"
		);
		formInputs.init(document.querySelectorAll("input, textarea"));
		$("[type=tel]").mask("000000000");
		sForm.initSend();
		// elements.counter('tvPackagesInTable', 4);
		const $appPacketsTv = this.dataElement;
		if (this.dataElement) {
			elements.counter($appPacketsTv, "tvPackagesInTable", 4);
		}
		prepareAllPossibleSearchEngines();
		const observer = lozad(".lozad", {
			// load: function(el) {
			// console.log('loading element');

			// Custom implementation to load an element
			// e.g. el.src = el.getAttribute('data-src');
			// },
			loaded: function (el) {
				if (el.hasAttribute("data-object-fit") && el.tagName == "PICTURE") {
					objectFitPolyfill(el.querySelector("img"));
				}
			},
		});
		observer.observe();

		const imgLoadOnStart = document.querySelectorAll("[data-lozad-start]");
		var timeoutLozad;
		timeoutLozad = setTimeout(() => {
			if (document.body.classList.contains("testing")) {
				[].forEach.call(document.querySelectorAll(".lozad"), (img) =>
					observer.triggerLoad(img)
				);
			} else {
				[].forEach.call(imgLoadOnStart, (img) => observer.triggerLoad(img));
			}
		}, 1000);

		paralax.init();
		alignItems();
		// scrollTo(this.$el);
		const offer_columns = Array.from(this.$el.querySelectorAll(".offer-column"));
		const offer_tables = Array.from(this.$el.querySelectorAll(".offer-table"));
		const offer_forms = Array.from(this.$el.querySelectorAll("[data-popup]"));

		offer_columns.forEach((offer_column) => {
			const offer_items = Array.from(
				offer_column.querySelectorAll(".offer-item:not(.toggle-on-smartphone)")
			);
			const mobile_button = Array.from(
				offer_column.querySelectorAll(".offer-table-mobile-buttons__toggle-button")
			);
			if (mobile_button.length == 0) {
				offer_items.forEach((offer_item, index) => {
					if (offer_items.length - 1 == index) {
						offer_item.classList.add("last");
					}
				});
			}
		});

		offer_tables.forEach((offer_table) => {
			const offer_trs = Array.from(offer_table.querySelectorAll("tr"));
			let last_tr;
			let last_tr_tds;
			offer_trs.forEach((offer_tr, index) => {
				const offer_tds = Array.from(
					offer_tr.querySelectorAll("td:not(.offer-table-bottom)")
				);
				if (offer_tds.length > 0) {
					last_tr = offer_tr;
				}
			});
			if (last_tr) {
				last_tr_tds = Array.from(last_tr.querySelectorAll("td"));
				last_tr_tds.forEach((last_tr_td, index) => {
					last_tr_td.classList.add("last");
				});
			}
		});
		offer_forms.forEach((offer_form) => {
			const recaptcha = offer_form.querySelector("#leadform_recaptcha");
			if (recaptcha) {
				window["leadform_recaptcha_" + recaptcha.getAttribute("data-form-id")] =
					grecaptcha.render(recaptcha, {
						sitekey: recaptcha.getAttribute("data-sitekey"),
						callback: function () {
							const recaptchaLeadformError = form.querySelector(
								"#leadform_recaptchaError"
							);
							if (recaptchaLeadformError.classList.contains("is-shown")) {
								recaptchaLeadformError.classList.remove("is-shown");
							}
						},
					});
			}
		});
	},
	template: "#offer-table",
	methods: {
		activateTable: function (isVisible, entry) {
			if (isVisible || this.$el.offsetParent !== null) {
				this.active = true;
				// console.log('war isVisible', isVisible, this.active);
			}
		},
		pushDataLayer: function (data) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(data);
		},
		fetchData: function () {
			// const errorField = diagnosticsApp.querySelector('[data-error-field]');
			let url = this.dataofferurl;
			// console.log(this.query);
			if (this.query.length > 0) {
				if (url.indexOf("?") > -1) {
					url = url.slice(0, url.indexOf("?"));
				}
				url = url + "?";
			}
			for (let i = 0; i < this.query.length; i++) {
				if (this.query[i]) {
					url = url + this.query[i];
					if (i < this.query.length - 1) {
						url = url + "&";
					}
				}
			}
			// console.log('vueApplication', this.$root);
			this.$root.showLoader = true;
			let method = "post";
			if (
				window.location.href.indexOf("localhost") > -1 ||
				window.location.href.indexOf("10.0.10.159") > -1
			) {
				method = "get";
			}
			requestHelper
				// .request(diagnosticsApp.getAttribute('method'), diagnosticsApp.getAttribute('data-from'))
				.request(method, url)
				.then((res) => {
					res = JSON.parse(res);
					this.offer_table = res.offer_table;
					this.offer_table_mobile = res.offer_table_mobile;
					this.switches = res.switches;
					this.bonus = res.bonus;
					this.packages = res.packages;
					this.popups = res.popups;
					// this.query_parameter = res.query_parameter;
					// this.query_value = res.query_value;
					if (res.offer_table) {
						this.one_column = res.offer_table.columns == 1;
						this.two_columns = res.offer_table.columns == 2;
						this.three_columns = res.offer_table.columns == 3;
					}

					if (res.switches) {
						if (res.switches.parameters.switch1) {
							for (
								let i = 0;
								i < res.switches.parameters.switch1.elements.length;
								i++
							) {
								let element = res.switches.parameters.switch1.elements[i];
								if (element.active == true) {
									this.query[0] = element.query_parameter + "=" + element.query_value;
								}
							}
						}

						if (res.switches.parameters.switch2) {
							for (
								let i = 0;
								i < res.switches.parameters.switch2.elements.length;
								i++
							) {
								let element = res.switches.parameters.switch2.elements[i];
								if (element.active == true) {
									this.query[1] = element.query_parameter + "=" + element.query_value;
								}
							}
						}

						if (res.switches.parameters.switch3) {
							for (
								let i = 0;
								i < res.switches.parameters.switch3.elements.length;
								i++
							) {
								let element = res.switches.parameters.switch3.elements[i];
								if (element.active == true) {
									this.query[2] = element.query_parameter + "=" + element.query_value;
								}
							}
						}
					}

					if (res.page_id) {
						this.query[3] = "page_id=" + res.page_id;
					}
					if (res.widget_id) {
						this.query[4] = "widget_id=" + res.widget_id;
					}
					if (res.data_layer) {
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push(res.data_layer);
					}
					this.dataElement = this.$el;
					// console.log(this.results);
					this.$root.showLoader = false;
				})
				.catch((e) => {
					console.log(e);
					this.isError = true;
					this.$root.showLoader = false;
					errors.showError(e.status, errorField);
				});
		},
	},
});
